import '../src/student/legacy'
